const configConstants = require('../config-constants');

const BASE_CONFIG = {
    siteBaseUrl: '',
    brandedUrl: '',
    twitterAccount: '',
    appHost: '',
    appHostName: '',
    leaguesAppHost: '',
    leaguesAppHostName: '',
    marketingAppHost: '',
    nextAppHost: '',
    apiHost: '',
    leaguesApiHost: '',
    leaguesSearchApiHost: '',
    searchApiHost: '',
    utrStatsApiHost: '',
    performanceStatsApiHost: '',
    liveScoresApiHost: '',
    messagingApiHost: '',
    groupsApiHost: '',
    rankingsApiHost: '',
    engageApiHost: '',
    rostersApiHost: '',
    userSiteHost: '',
    userSiteHostName: '',
    stripeHost: '',
    stripeClientId: '',
    stripeKey: '',
    googleApiKey: '',
    utrStripeAccountId: '',
    messaging: {},
    cdnUrl: '',
    publicPath: '',
    segmentKey: '',
    oldLogoClubIds: [],
    enableAnalytics: true,
    devtoolConfig: false,
    pixelId: '',
    appleClientId: '',
    statsigKey: '',
    defaultTitle: '',
    brazeApiKey: '',
    brazeEnableLogging: false,
    freshChatToken: '',
    voiceflowProjectId: '',
    voiceflowVersionId: '',
    collegeCornerAd: true,
    alwaysUseProxy: false,
    isLocalhost: false,
    outputPath: configConstants.outputPath,
    appCodePath: configConstants.appCodePath,
    applicationVersion: configConstants.applicationVersion,
    staticContentPath: configConstants.staticContentPath,
    searchDebounceMilliseconds: configConstants.searchDebounceMilliseconds,
};

module.exports = { BASE_CONFIG };
